import {
    Pipe,
    PipeTransform,
} from '@angular/core';

@Pipe({
    name: 'valueOr',
    pure: true,
    standalone: true,
})
export class ValueOrPipe implements PipeTransform {

    transform(value: any, alt: any = '--'): any {
        if (Array.isArray(value) && !value.length) {
            return alt;
        }
        if (typeof value === 'string') {
            return value?.trim()?.length ? value : alt;
        }
        return value ?? alt;
    }
}
